module.exports = __webpack_public_path__ + "images/saaremaa/payment/seb.png";